import { math } from 'polished';
import styled, { keyframes } from 'styled-components';
import { globalTheme, combineValues } from '@cld/component-theme';
import { iconMixin, iconSizeVariant } from '@cld/icon';

const rotation = keyframes`
   from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
`;

export default styled.div.attrs((props) => ({
  size: props.size || 'md',
  variant: props.variant || 'primary',
  color: combineValues(
    globalTheme.color[props.color] ?? (() => undefined),
    globalTheme.palette[props.variant] ?? (() => undefined),
    (color, themeColor) => color || themeColor
  )(props),
}))`
  ${iconMixin};
  animation: ${rotation} 1s infinite linear;
  border-radius: 100%;

  &:before {
    content: '';
    display: block;
    position: absolute;
    height: 100%;
    width: 100%;
    border-top: ${combineValues(
        iconSizeVariant(),
        (size) => math(`${size} / 8`)
      )}
      solid ${(props) => props.color};
    border-left: ${combineValues(
        iconSizeVariant(),
        (size) => math(`${size} / 8`)
      )}
      solid ${(props) => props.color};
    border-bottom: ${combineValues(
        iconSizeVariant(),
        (size) => math(`${size} / 8`)
      )}
      solid ${(props) => props.color};
    border-right: ${combineValues(
        iconSizeVariant(),
        (size) => math(`${size} / 8`)
      )}
      solid transparent;
    border-radius: 100%;
  }
`;
